import { usePathname } from 'next/navigation'
import { useEffect, useMemo, useState } from 'react'

import { ShareType, socialItems, SocialType } from './utils'

const POPUP_WINDOW_NAME_SUFFIX = ' | Cryptocom Price'
export function useShareLinkInfo(slug: string) {
  const pathName = usePathname()
  const tokenLink = new URL('https://crypto.com' + pathName)
  const params = tokenLink.searchParams
  params.set('utm_medium', 'organic+social')
  params.set('utm_campaign', 'price+page+share+button')
  const popupName = slug + POPUP_WINDOW_NAME_SUFFIX
  return {
    tokenLink: tokenLink.toString(),
    popupName,
  }
}

const DEFAULT_SOCIAL_TYPE = SocialType.twitter

export function useShareSocialTypes(shareType: ShareType) {
  const [socialType, setSocialType] = useState<SocialType>(DEFAULT_SOCIAL_TYPE)
  const displaySocialTypes = useMemo(() => {
    if (shareType === ShareType.Link) {
      return socialItems.filter(socialItem => socialItem.value !== SocialType.instagram)
    }
    return socialItems
  }, [shareType])
  // instagram do not support link share
  // when select link and socialType is ins,just set it to default
  useEffect(() => {
    if (shareType === ShareType.Link && socialType === SocialType.instagram) {
      setSocialType(DEFAULT_SOCIAL_TYPE)
    }
  }, [shareType, socialType])

  return {
    socialType,
    setSocialType,
    displaySocialTypes,
  }
}
